import { TabContext } from '@mui/lab'
import { Box, Tab, Tabs } from '@mui/material'
import React, { useEffect, useState, useRef } from 'react'
import EventTabPanel from './EventTabPanel'
import { EventWithAdditionalInfo } from '../../../../redux/event/teamMemberEvents/types'
import { useNavigate, useParams } from 'react-router'
import EventViewModal from '../EventCard/EventViewModal'
import showToast from '../../../Common/SweetAlert/ToastAlert'
import { useAppSelector } from '../../../../redux/store'
import { TEAM_MEMBER_EVENT_STATUS } from '../../../../constant/Event'
import {
  selectFilteredRegisteredEventsNotArchived,
  selectFilteredUnregisteredEventsNotArchivedAndNotCompletedAndActive,
} from '../../../../redux/event/teamMemberEvents/selector'

const eventTabs = [
  {
    label: 'Available',
    value: 'unregistered-events',
  },
  {
    label: 'Registered',
    value: 'registered-events',
  },
]

const EventTabs: React.FC = () => {
  const navigate = useNavigate()
  const [value, setValue] = useState<string>('unregistered-events')

  const { registrationCode } = useParams()
  const [eventData, setEventData] = useState<EventWithAdditionalInfo | null>(null)
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const modalOpenedRef = useRef(false)

  const unregisteredEvents = useAppSelector(
    selectFilteredUnregisteredEventsNotArchivedAndNotCompletedAndActive,
  )
  const registeredEvents = useAppSelector(selectFilteredRegisteredEventsNotArchived)

  const fetchSelectedEventData = () => {
    if (value === 'unregistered-events') {
      return unregisteredEvents
    } else if (value === 'registered-events') {
      return registeredEvents
    }
    return [] // Default return value
  }

  useEffect(() => {
    const fetchEvents = async () => {
      const events = [...unregisteredEvents, ...registeredEvents]

      if (registrationCode && !modalOpenedRef.current && events.length > 0) {
        try {
          const eventExists = events.find(
            (event: EventWithAdditionalInfo) => event.eventDetails.registrationCode === registrationCode,
          )

          if (eventExists) {
            if (eventExists.additionalInfo.status === TEAM_MEMBER_EVENT_STATUS.REGISTERED) {
              setValue('registered-events')
            }
            if (eventExists.additionalInfo.status === TEAM_MEMBER_EVENT_STATUS.UNREGISTERED) {
              setValue('unregistered-events')
            }
            setEventData(eventExists)
            setModalOpen(true)
            modalOpenedRef.current = true
          } else {
            showToast('error', 'Event not found')
            navigate('/events/event')
          }
        } catch (error) {
          console.error('An error occurred while fetching events:', error)
          showToast('error', 'An error occurred while fetching events')
        }
      }
    }

    fetchEvents()
  }, [registrationCode, unregisteredEvents, registeredEvents])

  // Reset modalOpenedRef when registrationCode changes
  useEffect(() => {
    modalOpenedRef.current = false
  }, [registrationCode])

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <TabContext value={value}>
        <Box
          sx={{
            borderBottom: 0.5,
            borderColor: 'divider',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          <Tabs value={value} onChange={handleTabChange} centered>
            {eventTabs.map((eventTab) => (
              <Tab key={eventTab.value} label={eventTab.label} value={eventTab.value} />
            ))}
          </Tabs>
        </Box>

        {/* Tab Panels */}
        <EventTabPanel value={value} eventData={fetchSelectedEventData()} />
      </TabContext>

      {modalOpen && eventData && <EventViewModal eventData={eventData} openModal={modalOpen} />}
    </Box>
  )
}

export default EventTabs
